import * as React from "react";
import { makeSimpleRoute } from "@ova-studio/react-hyper-admin";
const ActivityInfo = React.lazy(() => import('./pages/ActivityInfo'));
const ActivityModule = {
    routes: [
        makeSimpleRoute({
            path: '/activity',
            name: 'Деталі активності',
            element: React.createElement(ActivityInfo, null),
            loader: {
                sync: {
                    data: {
                        endpoint: 'activity',
                        queryString: true,
                    },
                },
            },
        }),
    ],
};
export default ActivityModule;
//# sourceMappingURL=config.js.map